import React from "react";
import { CircularProgress } from "@mui/material";
import { Styled } from "../../components/organizations/styles";
import useQueryOrganizations from "@/hooks/queries/useQueryOrganizations";
import OrganizationsList from "@/components/organizations";

const Organizations: React.FC = () => {
    const { data, isLoading } = useQueryOrganizations();

    if (isLoading) {
        return (
            <Styled.Container>
                <CircularProgress />
            </Styled.Container>
        );
    }

    return <OrganizationsList data={data} />;
};

export default Organizations;
